import { render, staticRenderFns } from "./styreneIndustrial.vue?vue&type=template&id=3b86758c&scoped=true&"
import script from "./styreneIndustrial.vue?vue&type=script&lang=js&"
export * from "./styreneIndustrial.vue?vue&type=script&lang=js&"
import style0 from "./styreneIndustrial.vue?vue&type=style&index=0&id=3b86758c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86758c",
  null
  
)

export default component.exports